<template>
  <HistoryQueries
    :animation="suggestionsAnimation"
    :max-items-to-render="x.query.searchBox ? 2 : 4"
    :suggestion-item-class="suggestionItemClass"
    class="-x-mr-2 x-flex x-gap-8 desktop:!x-flex-col desktop:x-gap-4"
    :class="{ '!x-flex-row !x-flex-wrap': !x.query.searchBox }"
  >
    <template #suggestion="{ suggestion }">
      <HistoryQuery
        class="x-suggestion-group-md hover:x-no-underline"
        :suggestion="suggestion"
        :remove-button-class="removeButtonClass"
        :suggestion-class="`x-suggestion x-suggestion-md x-text-lead-75 ${suggestionClass}`"
      >
        <template #default="{ query }">
          <HistoryIcon class="x-icon-lg desktop:x-icon-md" />
          <div class="x-group x-text2 x-text2-lg x-flex x-flex-col x-gap-2 x-font-light">
            <Highlight
              :text="suggestion.query"
              :highlight="query"
              class="group-hover:x-underline"
            />
            <HistoryQueryFilters
              class="x-w-192 desktop:x-w-128"
              :filters-list="suggestion.selectedFilters"
            />
          </div>
        </template>

        <template #remove-button-content>
          <span :aria-label="$t('historyQueries.removeLabel', { suggestion: suggestion.query })">
            <CrossTinyIcon class="x-icon-lg desktop:x-icon-md" />
          </span>
        </template>
      </HistoryQuery>
    </template>
  </HistoryQueries>
</template>

<script setup lang="ts">
import {
  CrossTinyIcon,
  Highlight,
  HistoryIcon,
  StaggeredFadeAndSlide,
  use$x,
} from '@empathyco/x-components'
import { HistoryQueries, HistoryQuery } from '@empathyco/x-components/history-queries'
import { computed } from 'vue'
import { useDevice } from '../../composables/use-device.composable'
import HistoryQueryFilters from '../history-query-filters.vue'

const suggestionsAnimation = StaggeredFadeAndSlide
const x = use$x()
const { isDesktopOrGreater } = useDevice()
const suggestionItemClass = computed(() => (isDesktopOrGreater.value ? 'x-w-full' : ''))
const removeButtonClass = computed(() => (!isDesktopOrGreater.value ? 'x-hidden' : ''))
const suggestionClass = computed(() =>
  !isDesktopOrGreater.value && !x.query.searchBox
    ? 'x-px-12 x-border-1 x-border-neutral-25 x-items-baseline'
    : '',
)
</script>

<style scoped></style>
